(function () {
  if (window.__tzCalendarCartInit) return;
  window.__tzCalendarCartInit = true;

  var STORAGE_KEY = 'tiziano.calendarCart.deferred.v1';
  var stripInFlight = false;
  var lastStrippedKeys = '';

  function roots() {
    return Array.from(document.querySelectorAll('[data-tz-calendar-cart]'));
  }

  function payload(root) {
    try {
      return JSON.parse(root.querySelector('[data-tz-calendar-payload]').textContent);
    } catch (error) {
      return { items: [] };
    }
  }

  function deferredItems() {
    try {
      var data = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
      return data && Array.isArray(data.items) ? data : null;
    } catch (error) {
      return null;
    }
  }

  function showStatus(root, selector, message) {
    var target = root.querySelector(selector);
    if (!target) return;
    target.textContent = message;
    target.hidden = false;
  }

  function setBusy(button, busy) {
    button.disabled = busy;
    button.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  function showCalendarOnlyCopy(root) {
    if (root.dataset.hasCalendar !== 'true' || root.dataset.hasRegular === 'true') return;

    var copy = root.querySelector('.tz-calendar-cart__copy');
    if (copy) copy.textContent = 'Nur Kalender im Warenkorb – gemeinsamer Versand im November.';

    var details = root.querySelector('.tz-calendar-cart__details');
    if (!details) return;

    var summary = details.querySelector('summary');
    var explanation = details.querySelector('p');
    if (summary) summary.textContent = 'Versandhinweis';
    if (explanation) explanation.textContent = 'Adventskalender werden separat versendet. Gratisgeschenke nach Einkaufswert gelten nicht für Adventskalender.';
  }

  function request(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) throw new Error('cart-request-failed');
      return response.json();
    });
  }

  function currentState() {
    var allRoots = roots();
    return {
      hasCalendar: allRoots.some(function (root) { return root.dataset.hasCalendar === 'true'; }),
      hasGift: allRoots.some(function (root) { return root.dataset.hasGift === 'true'; }),
      isMixed: allRoots.some(function (root) { return root.dataset.isMixed === 'true'; }),
      calendarGiftOnly: allRoots.some(function (root) { return root.dataset.calendarGiftOnly === 'true'; })
    };
  }

  function updateDeferredBanner() {
    var saved = deferredItems();
    roots().forEach(function (root) {
      var banner = root.querySelector('[data-tz-deferred]');
      if (!banner) return;
      if (!saved || saved.items.length === 0) {
        banner.hidden = true;
        return;
      }

      var cartEmpty = root.dataset.cartEmpty === 'true';
      var count = saved.items.reduce(function (sum, item) { return sum + Number(item.quantity || 0); }, 0);
      var copy = banner.querySelector('[data-tz-deferred-copy]');
      var restore = banner.querySelector('[data-tz-restore-deferred]');
      var details = banner.querySelector('[data-tz-deferred-details]');

      banner.hidden = false;
      if (copy) {
        copy.textContent = cartEmpty
          ? count + (count === 1 ? ' Artikel kann' : ' Artikel können') + ' jetzt zurück in den Warenkorb.'
          : count + (count === 1 ? ' Artikel ist' : ' Artikel sind') + ' für danach gespeichert.';
      }
      if (restore) restore.hidden = !cartEmpty;
      if (details) details.hidden = cartEmpty;
    });
  }

  // TIZIANO-Kundenregel: Gratisgeschenke duerfen niemals zusammen mit einem
  // Adventskalender im Warenkorb liegen - auch nicht, wenn kein weiterer
  // regulaerer Artikel vorhanden ist (das erkennt die reine Mixed-Cart-
  // Pruefung nicht, da Gratisgeschenke dort bewusst nicht als "regulaer"
  // gelten). Solange die eigentliche Gratisgeschenk-App (Dr Free Gift)
  // keine Kalender-Ausnahme hat, entfernen wir das Geschenk hier defensiv
  // clientseitig, sobald beide zusammen im Warenkorb auftauchen.
  function stripGiftsWhenCalendarPresent() {
    var state = currentState();
    if (!(state.hasCalendar && state.hasGift)) {
      lastStrippedKeys = '';
      return;
    }
    if (stripInFlight) return;

    var giftItems = [];
    roots().forEach(function (root) {
      payload(root).items.forEach(function (item) {
        if (item.group === 'gift') giftItems.push(item);
      });
    });
    if (!giftItems.length) return;

    var keysSignature = giftItems.map(function (item) { return item.key; }).sort().join(',');
    if (keysSignature === lastStrippedKeys) return; // already tried for this exact state, avoid loops

    var updates = {};
    giftItems.forEach(function (item) { updates[item.key] = 0; });

    stripInFlight = true;
    lastStrippedKeys = keysSignature;

    request('/cart/update.js', { updates: updates })
      .then(function (updatedCart) {
        // Die Geschenke wurden erfolgreich entfernt - die data-Attribute
        // stammen aber noch aus dem urspruenglichen Server-Render und wuerden
        // den Checkout sonst dauerhaft blockiert lassen, obwohl der
        // Warenkorb laengst korrekt ist. Deshalb hier direkt aktualisieren.
        roots().forEach(function (root) {
          root.dataset.hasGift = 'false';
          root.dataset.calendarGiftOnly = 'false';
          showCalendarOnlyCopy(root);
        });

        // Die entfernten Gratisgeschenk-Zeilen bleiben sonst als
        // Server-gerenderte DOM-Elemente sichtbar (id="CartItem-<key>"),
        // obwohl sie im echten Warenkorb laengst nicht mehr existieren -
        // das sah fuer Kunden so aus, als wuerde das Geschenk "nie
        // verschwinden". Deshalb hier gezielt aus dem DOM entfernen, statt
        // auf eine vollstaendige Section-Aktualisierung zu warten.
        giftItems.forEach(function (item) {
          var row = document.getElementById('CartItem-' + item.key);
          if (row && row.parentNode) {
            row.parentNode.removeChild(row);
          }
        });

        // Dr Free Gift aktualisiert den Zaehler teils schon vor diesem Callback.
        // Ein weiteres manuelles Minus wuerde dann den verbliebenen Kalender
        // faelschlich als "0 Artikel" anzeigen. Die Shopify-Antwort ist hier
        // die einzige verlaessliche Quelle fuer den aktuellen Artikelzaehler.
        document.querySelectorAll('cart-count, [data-cart-count]').forEach(function (el) {
          el.textContent = String(updatedCart.item_count);
          el.hidden = updatedCart.item_count === 0;
        });

        applyGuardState();
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function () {
        // Bewusst still: der Checkout-Guard unten blockiert den Kauf ohnehin,
        // solange Kalender + Gratisgeschenk gemeinsam erkannt werden.
      })
      .then(function () {
        stripInFlight = false;
      });
  }

  // Die Gratisgeschenk-App wertet den Warenkorb unabhaengig von uns selbst
  // periodisch/eventbasiert neu aus und fuegt ein Geschenk teils erneut ein,
  // bevor unser eigener Entfernen-Request beim Server durch ist. Fuer die
  // Kundschaft sah das wie ein wiederholtes Aufploppen und Verschwinden des
  // Geschenks aus. Deshalb blenden wir jede sichtbare Geschenk-Zeile sofort
  // (synchron, ohne auf den Server zu warten) aus, sobald ein Kalender im
  // Warenkorb liegt - unabhaengig davon, wie oft die App sie neu einfuegt.
  function hideGiftRowsImmediately() {
    if (!currentState().hasCalendar) return;
    document.querySelectorAll('.cart-item--reward-gift').forEach(function (row) {
      if (row.style.display !== 'none') row.style.display = 'none';
    });
  }

  function applyGuardState() {
    hideGiftRowsImmediately();
    var state = currentState();
    document.documentElement.classList.toggle('tz-cart-has-calendar', state.hasCalendar);
    document.documentElement.classList.toggle('tz-cart-is-mixed', state.isMixed);
    document.documentElement.classList.toggle('tz-cart-calendar-gift-only', state.calendarGiftOnly);

    var blockCheckout = state.isMixed || (state.hasCalendar && state.hasGift);

    document.querySelectorAll('button[name="checkout"][form], input[name="checkout"][form], form[action*="/cart"] button[name="checkout"], form[action*="/cart"] input[name="checkout"]').forEach(function (button) {
      if (blockCheckout) {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        button.dataset.tzCalendarDisabled = 'true';
      } else if (button.dataset.tzCalendarDisabled === 'true') {
        button.disabled = false;
        button.removeAttribute('aria-disabled');
        delete button.dataset.tzCalendarDisabled;
      }
    });

    updateDeferredBanner();
    stripGiftsWhenCalendarPresent();
  }

  function splitCart(button) {
    var root = button.closest('[data-tz-calendar-cart]');
    if (!root) return;
    var keep = button.dataset.tzSplitKeep;
    var items = payload(root).items;

    // Zurueckgestellt wird alles, was nicht zur behaltenen Gruppe gehoert -
    // Gratisgeschenke werden nie zurueckgestellt, da sie automatisch anhand
    // des Warenwerts neu berechnet werden.
    var deferred = items.filter(function (item) { return item.group !== keep && item.group !== 'gift'; });

    // Entfernt aus dem aktuellen Warenkorb wird alles, was nicht zur
    // behaltenen Gruppe gehoert. Gratisgeschenke werden zusaetzlich IMMER
    // entfernt, wenn der Kalender behalten wird - sie duerfen laut
    // Kundenregel nie zusammen mit einem Kalender bestellt werden.
    var removed = items.filter(function (item) {
      if (item.group === 'gift') return keep === 'calendar';
      return item.group !== keep;
    });

    if (!deferred.length || !removed.length) {
      showStatus(root, '[data-tz-calendar-status]', 'Die Versandgruppen konnten nicht eindeutig getrennt werden. Es wurde nichts verändert.');
      return;
    }

    setBusy(button, true);
    root.querySelectorAll('[data-tz-split-keep]').forEach(function (other) { other.disabled = true; });

    // Der beim Laden der Seite eingebettete Warenkorb-Snapshot kann veraltet
    // sein - zum Beispiel wenn zwischenzeitlich ein automatisch
    // hinzugefuegtes Gratisgeschenk per AJAX wieder entfernt wurde (siehe
    // stripGiftsWhenCalendarPresent). Ein /cart/update.js-Aufruf, der auch
    // nur einen nicht mehr existierenden Line-Item-Key enthaelt, wird von
    // Shopify komplett mit 422 abgelehnt - dann passiert scheinbar gar
    // nichts. Deshalb hier zuerst den echten, aktuellen Warenkorb holen und
    // nur tatsaechlich vorhandene Keys aktualisieren.
    fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (liveCart) {
        var liveKeys = {};
        liveCart.items.forEach(function (item) { liveKeys[item.key] = true; });

        var removedLive = removed.filter(function (item) { return liveKeys[item.key]; });
        var deferredLive = deferred.filter(function (item) { return liveKeys[item.key]; });

        if (!deferredLive.length || !removedLive.length) {
          root.querySelectorAll('[data-tz-split-keep]').forEach(function (other) { other.disabled = false; });
          setBusy(button, false);
          showStatus(root, '[data-tz-calendar-status]', 'Die Versandgruppen konnten nicht eindeutig getrennt werden. Es wurde nichts verändert.');
          return;
        }

        localStorage.setItem(STORAGE_KEY, JSON.stringify({
          createdAt: new Date().toISOString(),
          group: deferredLive[0].group,
          items: deferredLive.map(function (item) {
            return {
              id: item.id,
              quantity: item.quantity,
              title: item.title,
              group: item.group,
              properties: item.properties || {},
              selling_plan: item.selling_plan || null
            };
          })
        }));

        var updates = {};
        removedLive.forEach(function (item) { updates[item.key] = 0; });

        return request('/cart/update.js', { updates: updates })
          .then(function () { window.location.assign('/cart?tz_split=1'); });
      })
      .catch(function () {
        localStorage.removeItem(STORAGE_KEY);
        root.querySelectorAll('[data-tz-split-keep]').forEach(function (other) { other.disabled = false; });
        setBusy(button, false);
        showStatus(root, '[data-tz-calendar-status]', 'Die Aufteilung hat nicht funktioniert. Dein Warenkorb wurde nicht verändert. Bitte versuche es erneut.');
      });
  }

  function restoreDeferred(button) {
    var root = button.closest('[data-tz-calendar-cart]');
    var saved = deferredItems();
    if (!root || !saved || !saved.items.length) return;

    setBusy(button, true);
    fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        if (cart.item_count > 0) throw new Error('cart-not-empty');
        var items = saved.items.map(function (item) {
          var entry = {
            id: item.id,
            quantity: item.quantity
          };
          if (item.properties && !Array.isArray(item.properties) && Object.keys(item.properties).length) {
            entry.properties = item.properties;
          }
          if (item.selling_plan) entry.selling_plan = item.selling_plan;
          return entry;
        });
        return request('/cart/add.js', { items: items });
      })
      .then(function () {
        localStorage.removeItem(STORAGE_KEY);
        window.location.assign('/cart?tz_restored=1');
      })
      .catch(function (error) {
        setBusy(button, false);
        showStatus(root, '[data-tz-deferred-status]', error.message === 'cart-not-empty'
          ? 'Bitte schließe zuerst die aktuelle Bestellung ab. Danach kannst du die vorgemerkten Artikel in den leeren Warenkorb zurückholen.'
          : 'Die vorgemerkten Artikel konnten nicht geladen werden. Sie bleiben gespeichert; bitte versuche es erneut.');
      });
  }

  document.addEventListener('click', function (event) {
    var checkout = event.target.closest('button[name="checkout"][form], input[name="checkout"][form], form[action*="/cart"] button[name="checkout"], form[action*="/cart"] input[name="checkout"]');
    if (checkout && (currentState().isMixed || (currentState().hasCalendar && currentState().hasGift))) {
      event.preventDefault();
      var mixedRoot = roots().find(function (candidate) { return candidate.dataset.isMixed === 'true' || candidate.dataset.calendarGiftOnly === 'true'; });
      if (mixedRoot) showStatus(mixedRoot, '[data-tz-calendar-status]', 'Bitte wähle zuerst, welche Versandgruppe du bestellen möchtest.');
      return;
    }

    var split = event.target.closest('[data-tz-split-keep]');
    if (split) {
      event.preventDefault();
      splitCart(split);
      return;
    }

    var restore = event.target.closest('[data-tz-restore-deferred]');
    if (restore) {
      event.preventDefault();
      restoreDeferred(restore);
    }
  });

  document.addEventListener('cart:updated', function () {
    window.setTimeout(applyGuardState, 100);
  });
  document.addEventListener('cart:refresh', function () {
    window.setTimeout(applyGuardState, 350);
  });

  // Zusaetzliche, eventunabhaengige Absicherung: Die Gratisgeschenk-App fuegt
  // ihre Zeile teils per direkter DOM-Manipulation ein, ohne ein cart:updated/
  // cart:refresh Event auszuloesen, auf das wir sonst reagieren wuerden. Ein
  // MutationObserver bemerkt jede neu eingefuegte Geschenk-Zeile sofort - egal
  // wie oft die App sie neu einfuegt - und blendet sie ohne Verzoegerung aus.
  if (window.MutationObserver) {
    var giftRowWatcher = new MutationObserver(function (mutations) {
      var sawGiftNode = false;
      mutations.forEach(function (mutation) {
        (mutation.addedNodes || []).forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('.cart-item--reward-gift')) sawGiftNode = true;
          if (node.querySelector && node.querySelector('.cart-item--reward-gift')) sawGiftNode = true;
        });
      });
      if (sawGiftNode) {
        hideGiftRowsImmediately();
        applyGuardState();
      }
    });
    giftRowWatcher.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyGuardState, { once: true });
  } else {
    applyGuardState();
  }
})();
